import {
    ArticleAction,
    ArticleState,
    NARRATE,
    LOAD_PLAYER,
    PLAY,
    SET_ERROR,
    SET_LOADING,
    SET_SUCCESS
} from '../../constants/narrationConstants';

const initialState: ArticleState = {
    article: null,
    request_url: '',
    narrated: false,
    loading: false,
    error: '',
    success: ''
};

export default (state = initialState, action: ArticleAction) => {
    switch (action.type) {
        case NARRATE:
            return {
                ...state,
                request_url: action.payload,
            };
        case LOAD_PLAYER:
            return {
                ...state,
                article: action.payload,
                narrated: true
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case PLAY:
            return {
                ...state,
                user: null,
                authenticated: false,
                loading: false
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case SET_SUCCESS:
            return {
                ...state,
                success: action.payload
            };
        default:
            return state;
    }
}
